export default __webpack_public_path__ + "static/individual.eglo-20ae0611469283b4c0b321ed8a5f23f3.png";